/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Отображение для сообщения на странице отписки от рассылки.
   */
  app.UnsubscribeMessageView = app.View.extend({
    el: '.message_block',
    events: {
      'click .unsubscribe': 'unsubscribe',
      'click .resubscribe': 'resubscribe',
      'click .resubscribe-with-comment': 'resubscribeWithComment',
      'input .unsubscribe-reason': 'validateInput',
    },
    subscribeType: 'is_subscribed_for_newsletter',

    run: function (options) {
      if (options && options.type) {
        this.subscribeType = options.type;
      }
      this.successTemplate = app.helpers.TemplateHelper.getTemplate('#unsubscribe-success-template');
      this.errorTemplate = app.helpers.TemplateHelper.getTemplate('#unsubscribe-error-template');
      this.resubscribeTemplate = app.helpers.TemplateHelper.getTemplate('#resubscribe-template');
      this.commentSelector = '.unsubscribe-reason';
      this.model = new app.UnsubscribeByToken();
      this.token = app.helpers.UrlHelper.getUrlParameter('encrypted-email', location.search);
      this.newToken = app.helpers.UrlHelper.getUrlParameter('encrypted-new-email', location.search);
      this.listenTo(this.model, 'error', this.error);
    },

    /**
     * Получение комментария.
     * @returns {string} Комментарий
     */
    getComment: function () {
      var $comment = $(this.commentSelector);
      return $comment.length ? $comment.val() : '';
    },

    /**
     * Вставка шаблона с успешной отпиской.
     */
    unsubscribeSuccess: function () {
      this.$el.html(this.successTemplate({
        model: this.model.toJSON(),
      }));
    },

    /**
     * Вставка шаблона с успешным восстановлением подписки.
     */
    resubscribeSuccess: function () {
      this.$el.html(this.resubscribeTemplate({
        model: this.model.toJSON(),
      }));
    },

    /**
     * Редирект в кабинет пользователя при успешном восстановлении подписки.
     */
    resubscribeWithCommentSuccess: function () {
      app.helpers.RedirectHelper.locationAssign('/cabinet');
    },

    /** @inheritDoc */
    error: function (model) {
      this.$el.html(this.errorTemplate({
        model: model.toJSON(),
      }));
    },

    /**
     * Отписка от рассылки.
     * @param {Event} e Событие элемента
     */
    unsubscribe: function (e) {
      e.preventDefault();
      var that = this,
        comment = this.getComment(),
        data = {};
      data.token = that.token;
      data.newToken = that.newToken;
      data.comment = comment;
      data[this.subscribeType] = 0;

      this.listenToOnce(this.model, 'sync', this.unsubscribeSuccess());
      this.model.save(data);
    },

    /**
     * Переподписаться на рассылку.
     * @param {Event} e Событие элемента
     */
    resubscribe: function (e) {
      e.preventDefault();
      var that = this,
        comment = this.getComment(),
        data = {};
      data.token = that.token;
      data.newToken = that.newToken;
      data.comment = comment;
      data[this.subscribeType] = 1;

      this.listenToOnce(this.model, 'sync', this.resubscribeSuccess());
      this.model.save(data);
    },

    /**
     * Переподписаться на рассылку с комментарием.
     * @param {Event} e Событие элемента
     */
    resubscribeWithComment: function (e) {
      e.preventDefault();
      var that = this,
        comment = this.getComment(),
        data = {};
      data.token = that.token;
      data.newToken = that.newToken;
      data.comment = comment;
      data[this.subscribeType] = 1;

      this.listenToOnce(this.model, 'sync', this.resubscribeWithCommentSuccess());
      this.model.save(data);
    },

    /**
     * Вызывает функцию для валидации ввода символов
     * @param {Event} e Событие input
     */
    validateInput: function (e) {
      app.helpers.InputHelper.handleFieldInput(e, 'review');
    }
  });
})();

}.call(window));